import { Flex } from "@simplybusiness/mobius";
import classNames from "classnames/dedupe";

type InsurersProps = {
  className?: string;
  insurersLogosSet: InsurersForVertical;
};

// Insurers to show for landlord Q2Q or shop Q2Q
export type InsurersForVertical =
  | "landlord"
  | "shop"
  | "business"
  | "professional"
  | "commercial_landlord"
  | "contractors_combined";

const VERTICALS = [
  "landlord",
  "shop",
  "business",
  "professional",
  "commercial_landlord",
  "contractors_combined",
];

export const BUSINESS_SHOP_INSURERS = [
  "hiscox",
  "axa",
  "zurich",
  "aig",
  "lexicon",
  "maltings",
  "churchill",
  "chiswell",
  "covea",
  "finsbury",
];

export const PROFESSIONAL_INSURERS = [
  "hiscox",
  "axa",
  "zurich",
  "aig",
  "rsa",
  "maltings",
  "churchill",
  "chiswell",
  "covea",
  "finsbury",
];

export const LANDLORD_INSURERS = [
  "axa",
  "churchill",
  "zurich",
  "covea",
  "aro",
  "modus",
  "melius",
  "uno",
  "chiswell",
  "finsbury",
  "maltings",
];

export const COMMERCIAL_LANDLORD_INSURERS = [
  "hiscox",
  "axa",
  "zurich",
  "aig",
  "rsa",
  "maltings",
  "churchill",
  "chiswell",
  "covea",
  "finsbury",
];

export const CONTRACTORS_COMBINED_INSURERS = ["qbe", "chiswell", "maltings"];

//Given a preambleName, return the insurers icon set to use, or null if the preambleName doesn't map to a valid insurers icon set
export const getVerticalFromPreambleName = (
  preambleName?: string,
): InsurersForVertical | null => {
  if (!preambleName?.endsWith("_insurer_logos")) {
    return null;
  }

  const vertical = preambleName.replace("_insurer_logos", "");

  if (!vertical || !VERTICALS.includes(vertical)) {
    return null;
  }

  return vertical as InsurersForVertical;
};

const getInsurersSet = (vertical: InsurersForVertical) => {
  switch (vertical) {
    case "landlord":
      return LANDLORD_INSURERS;
    case "professional":
      return PROFESSIONAL_INSURERS;
    case "commercial_landlord":
      return COMMERCIAL_LANDLORD_INSURERS;
    case "contractors_combined":
      return CONTRACTORS_COMBINED_INSURERS;
    default:
      return BUSINESS_SHOP_INSURERS;
  }
};

export const Insurers = (props: InsurersProps) => {
  const { className } = props;
  const insurersSet = getInsurersSet(props.insurersLogosSet);
  const classes = classNames(
    "mobius",
    "mobius-insurers",
    `mobius-insurers--${props.insurersLogosSet}`,
    className,
  );

  return (
    <Flex
      data-testid={`mobius-insurers-${props.insurersLogosSet}`}
      className={classes}
    >
      {insurersSet.map(insurer => (
        <div
          data-testid={`mobius-insurers__insurer--${insurer}`}
          key={insurer}
          className={`mobius-insurers-${props.insurersLogosSet} mobius-insurers__insurer--${insurer}`}
        />
      ))}
    </Flex>
  );
};
